import { render } from "./Attachments.vue?vue&type=template&id=cad233cc"
import script from "./Attachments.vue?vue&type=script&lang=js"
export * from "./Attachments.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/Attachments.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cad233cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cad233cc', __exports__)) {
    console.log('reload')
    api.reload('cad233cc', __exports__)
  }
  
  module.hot.accept("./Attachments.vue?vue&type=template&id=cad233cc", () => {
    console.log('re-render')
    api.rerender('cad233cc', render)
  })

}


export default __exports__